import { NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';

import { MwSelectComponent } from './select.component';
import { CommonModule } from '@angular/common';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MwSelectFooterDirective } from './select.directives';

@NgModule({
  imports: [
    CommonModule,
    NgSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
  ],
  exports: [MwSelectComponent, MwSelectFooterDirective],
  declarations: [MwSelectComponent, MwSelectFooterDirective],
  providers: [],
})
export class MwSelectModule {}
